export default {
  methods: {
    formatOutageDate(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return this.$t("outage_date_at_time", {
        date: `${day}.${month}.${date.getFullYear()}`,
        time: `${hours}:${minutes}`,
      });
    },
    outageDaysActive(dateString) {
      if (!dateString) return 0;
      const created = new Date(dateString);
      const diff = Date.now() - created.getTime();
      return Math.floor(diff / (1000 * 60 * 60 * 24));
    },
  },
};
